<template>
  <div class="position-absolute top-0 bottom-0 right-0 left-0 d-flex align-items-center justify-content-center">
    <div
      class="position-absolute top-0 bottom-0 right-0 left-0 bg-white opacity-7 "
      style="z-index: 9999;">
    </div>
    <div style="z-index: 9999;">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import BaseLoader from "@/components/BaseLoader.vue";
export default {
  name: "Overlay",
  components: {
    BaseLoader
  },
  props: {
  }
}
</script>

<style lang="scss" scoped></style>